var map = {
	"./mountain-badge--dark.svg": 906,
	"./mountain-badge--light.svg": 907,
	"./surf-badge--dark.svg": 908,
	"./surf-badge--light.svg": 909,
	"./tide-badge--dark.svg": 910,
	"./tide-badge--light.svg": 911,
	"./weather-badge--dark.svg": 912,
	"./weather-badge--light.svg": 913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 905;